import { Alert, Conditional, TabItemProps, Tabs, Text } from '@consumidor-positivo/aurora';

import { SHOffer } from '../../../../services/sortingHat';
import { OfferCard } from '../../../../components/OfferCard';
import { OfferSkeleton } from '../../../../components/OfferSkeleton';

import './styles.scss';
import { useOfferListTab } from './hook';

type OfferForBenefits = TabItemProps & { list: SHOffer[] };

export type OfferListTabProps = {
  user: any;
  offers: SHOffer[] | [];
  offerForBenefits: OfferForBenefits[];
  location: string;
  loading: boolean;
  onClickBenefitsTabs: (value: string, filterType?: string) => void;
  OffersMiddleAd?: any;
  benefitsFilterText?: string;
  initalBenefitTab?: string;
};

export function OfferListTab(props: OfferListTabProps) {
  const { user, location, loading, offers, benefitsFilterText, onClickBenefitsTabs } = props;
  const { benefitsTabs, adsCard } = useOfferListTab(props);

  if (loading) {
    return <OfferSkeleton />;
  }

  if (offers.length <= 0) {
    return (
      <Alert
        type={2}
        status="error"
        title={{
          content: 'Ops, no momento não encontramos ofertas disponíveis',
        }}
      />
    );
  }

  return (
    <>
      <div>
        <Conditional
          condition={benefitsTabs?.length > 1}
          renderIf={
            <div className="offer-list-tab__benefits-container">
              <Text variant="body-small" color="secondary" weight="semibold">
                {benefitsFilterText}
              </Text>
              <Tabs initialTab={props?.initalBenefitTab} tabs={benefitsTabs} onClick={(value) => onClickBenefitsTabs(value, 'benefits')} />
            </div>
          }
          renderElse={
            <div className="offer-list-tab__container">
              {offers?.map((offer, index) => {
                return (
                  <>
                    <OfferCard key={`offer-list-tab-${index}`} offer={offer} index={index} location={location} user={user} />
                    {adsCard(index)}
                  </>
                );
              })}
            </div>
          }
        />
      </div>
      <div className="offer-list-tab__alert">
        <Alert
          type={2}
          status="info"
          title={{
            content: 'Sujeito à análise de crédito',
          }}
        />
      </div>
    </>
  );
}
